<div class="card">
  <app-header titulo="Parâmetros de Produção" descricao="Parâmetros de produção utilizados na integração com o ERP"></app-header>
  <p-toast />
  <p-table [value]="producaoParams" dataKey="sufCodigo" [loading]="loading" #dt [globalFilterFields]="['empCodemp','varCodigo','sufCodigo','deProcesso','deProdFinal']" styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines" [rowsPerPageOptions]="[20, 50, 100]" [paginator]="true" [rows]="20" [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros">
    <ng-template pTemplate="caption">
      <div class="flex">
        <a [routerLink]="['novo']"><button icon="pi pi-plus" label="Novo Cadastro" pButton></button></a>

        <span class="p-input-icon-left ml-auto">
          <i class="pi pi-search"></i>
          <input pInputText type="text" (input)="dt.filterGlobal($any($event.target)?.value, 'contains')" placeholder="Pesquisar" />
        </span>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th pSortableColumn="empCodemp">
              Empresa
              <p-sortIcon field="empCodemp" />
              <p-columnFilter field="empCodemp" matchMode="in" display="menu" [showApplyButton]="false" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                  <p-multiSelect [ngModel]="value" [options]="empresas" placeholder="Todas" [filter]="true" selectedItemsLabel="{0} selecionadas" (onChange)="filter($event.value)"></p-multiSelect>
                </ng-template>
              </p-columnFilter>
            </th>
            <th pSortableColumn="varCodigo">
              Variedade
              <p-sortIcon field="varCodigo" />
              <p-columnFilter field="varCodigo" matchMode="in" display="menu" [showApplyButton]="false" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                  <p-multiSelect [ngModel]="value" [options]="variedades" placeholder="Todas" [filter]="true" selectedItemsLabel="{0} selecionadas" (onChange)="filter($event.value)"></p-multiSelect>
                </ng-template>
              </p-columnFilter>
            </th>
            <th>Sufixo</th>
            <th pSortableColumn="deProcesso">
              Processo
              <p-sortIcon field="deProcesso" />
            </th>
            <th>Produto Final</th>
            <th pSortableColumn="ativo">
              Status
              <p-sortIcon field="ativo" />
              <p-columnFilter field="ativo" matchMode="equals" display="menu" [showApplyButton]="false" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                  <p-dropdown [ngModel]="value" [options]="statusOptions" optionLabel="label" optionValue="value" placeholder="Todos" [showClear]="true" (onChange)="filter($event.value)"></p-dropdown>
                </ng-template>
              </p-columnFilter>
            </th>
            <th></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-producaoParam>
        <tr>
            <td>{{ producaoParam.empCodemp }}</td>
            <td>{{ producaoParam.varCodigo }}</td>
            <td>{{ producaoParam.sufCodigo }}</td>
            <td>{{ producaoParam.deProcesso }}</td>
            <td>{{ producaoParam.deProdFinal }}</td>
            <td>
              <div class="flex align-items-center gap-2">
                <p-inputSwitch
                  [(ngModel)]="producaoParam.ativo"
                  (onChange)="alternarStatus(producaoParam)"
                  [pTooltip]="producaoParam.ativo ? 'Desativar registro' : 'Reativar registro'">
                </p-inputSwitch>
                <p-tag [value]="producaoParam.ativo ? 'Ativo' : 'Inativo'" [severity]="producaoParam.ativo ? 'success' : 'danger'"></p-tag>
              </div>
            </td>
            <td>
              <a [routerLink]="['editar', producaoParam.empCodemp, producaoParam.varCodigo, producaoParam.sufCodigo]">
                <p-button icon="pi pi-pencil"
                          severity="primary"
                          class="m-2"
                          [rounded]="true"
                          [outlined]="true" >
                </p-button>
              </a>
            </td>

        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <td colspan="10">Nenhum registro encontrado</td>
    </ng-template>
  </p-table>
  <p-confirmDialog [style]="{ width: '450px' }" />
</div>
